module.exports = __webpack_public_path__ + "static/zig_zag_wool-e35bff252e2938f174fe2974babb0928.png";